// Google Maps
var GoogleMapsLoader = require('google-maps');
GoogleMapsLoader.KEY = 'AIzaSyBIp2YTRwT9FGB1ouqHRp9KmKwvCoA8dVg';
GoogleMapsLoader.LANGUAGE = 'fr';
GoogleMapsLoader.VERSION = '3.34';

// Google maps initialization
function initialize(google, id, lat, lng, marker_icon) {
    var directionsService = new google.maps.DirectionsService;
    var directionsDisplay = new google.maps.DirectionsRenderer({
        suppressMarkers: true
    });

    var mapOptions = {
        zoom: 13,
        center: new google.maps.LatLng({lat: lat, lng: lng}),
        scrollwheel:false,
        scaleControl:false,
        streetViewControl:false,
        mapTypeControl:false,
        mapTypeControlOptions: {
            mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style']
        }
    }

    // Snazzy maps colors
    var featureOpts = [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#46bcec"},{"visibility":"on"}]}];

    // Init colorize map
    var customMapType = new google.maps.StyledMapType(featureOpts, {name: 'Custom Style'});

    // Create Google maps
    var map = new google.maps.Map(document.getElementById(id), mapOptions);

    // Apply colors on Maps
    map.mapTypes.set('map_style', customMapType);
    map.setMapTypeId('map_style');
    directionsDisplay.setMap(map);

    // Marker
    // Custom marker
    var marker = new google.maps.Marker({
        position: new google.maps.LatLng(lat, lng),
        map: map,
        icon : marker_icon
    });


    // Itinéraire calculation && event listener
    var onChangeHandler = function(e) {
        e.preventDefault();
        
        // Show loading button
        document.getElementById('submit_calculate_itineraire').classList.add("cc-loading");


        calculateAndDisplayRoute(directionsService, directionsDisplay, lat, lng, marker_icon, map);
    };
    document.getElementById('calculate_itineraire').addEventListener('submit', onChangeHandler);
}


function calculateAndDisplayRoute(directionsService, directionsDisplay, lat, lng, marker_icon, map) {

    directionsService.route({
      // origin: new google.maps.Geocoding(document.getElementById('origin').value),
      origin: document.getElementById('origin').value,
      destination: new google.maps.LatLng({lat: lat, lng: lng}),
      travelMode: 'DRIVING'
    }, 
    function(response, status) {

      if (status === 'OK') {
        directionsDisplay.setDirections(response);
        directionsDisplay.setPanel(document.getElementById('itineraire_road'));

        // Place marker on "origin" point
        var markerOrigin = new google.maps.Marker({
            position: response.routes[0].legs[0].start_location,
            map: map,
            icon: marker_icon
        });


        // Remove loading button
        document.getElementById('submit_calculate_itineraire').classList.remove("cc-loading");

      } else {
        window.alert('Directions request failed due to ' + status);
      }
    });
}

$(function () {
    /*
     -- @ GOOGLE MAPS PLUGIN @ --
        * Used in:
            - Agency detail page
    */
    if($('#ggmaps').length) {
        var 
            lat = $('#ggmaps').data('maps-lat'),
            lng = $('#ggmaps').data('maps-lng'),
            marker = $('#ggmaps').data('maps-marker');

        // Init google Maps
        GoogleMapsLoader.load(function(google) {
            initialize(google, 'ggmaps', lat, lng, marker);
        });
    }
});


// WEBPACK FOOTER //
// ./assets/js/google-maps.js